// material-ui
import { alpha, createTheme } from '@mui/material/styles';

// third-party
import { presetDarkPalettes, presetPalettes, PalettesProps } from '@ant-design/colors';

// project import
import ThemeOption from './theme';
import { ThemeMode } from 'config';

// types
import { PaletteThemeProps } from 'types/theme';
import { PresetColor } from 'types/config';

// ==============================|| DEFAULT THEME - PALETTE ||============================== //

export default function Palette(mode: ThemeMode, presetColor: PresetColor) {
  const colors: PalettesProps = mode === ThemeMode.DARK ? presetDarkPalettes : presetPalettes;

  let greyPrimary = [
    '#ffffff',
    '#fafafa',
    '#f5f5f5',
    '#f0f0f0',
    '#d9d9d9',
    '#bfbfbf',
    '#8c8c8c',
    '#595959',
    '#262626',
    '#141414',
    '#000000'
  ];
  let greyAscent = ['#fafafa', '#bfbfbf', '#434343', '#1f1f1f'];
  let greyConstant = ['#fafafb', '#e6ebf1'];

  if (mode === ThemeMode.DARK) {
    greyPrimary = ['#000000', '#141414', '#1e1e1e', '#595959', '#8c8c8c', '#bfbfbf', '#d9d9d9', '#f0f0f0', '#f5f5f5', '#fafafa', '#ffffff'];
    // greyPrimary.reverse();
    greyAscent = ['#fafafa', '#bfbfbf', '#434343', '#1f1f1f'];
    greyConstant = ['#121212', '#d3d8db'];
  }

  if (mode === ThemeMode.CLASSIC) {
    greyPrimary = ['#000000', '#1a1a1a', '#2d2d2d', '#404040', '#525252', '#666666', '#808080', '#999999', '#b3b3b3', '#cccccc', '#e6e6e6'];
    greyAscent = ['#1a1a1a', '#2d2d2d', '#404040', '#525252'];
    greyConstant = ['#000000', '#1a1a1a'];
  }

  colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant];

  const paletteColor: PaletteThemeProps = ThemeOption(colors, presetColor, mode);

  return createTheme({
    palette: {
      mode: mode === ThemeMode.CLASSIC ? 'dark' : mode, // Use dark mode for classic theme
      common: {
        black: '#000',
        white: '#fff'
      },
      ...paletteColor,
      error: {
        ...paletteColor.error,
        // Override error colors for dark mode to be lighter and brighter
        ...(mode === ThemeMode.DARK && {
          main: '#ff6b6b', // Lighter, brighter red
          light: '#ff8e8e', // Even lighter for borders and highlights
          dark: '#ff5252', // Slightly darker but still bright
        }),
        // Override error colors for classic mode to be lighter and brighter (same as dark mode)
        ...(mode === ThemeMode.CLASSIC && {
          main: '#ff6b6b', // Lighter, brighter red
          light: '#ff8e8e', // Even lighter for borders and highlights
          dark: '#ff5252', // Slightly darker but still bright
        })
      },
      text: {
        primary: mode === ThemeMode.CLASSIC ? '#FFD700' : (mode === ThemeMode.DARK ? alpha(paletteColor.grey[900]!, 0.87) : paletteColor.grey[700]),
        secondary: mode === ThemeMode.CLASSIC ? '#cccccc' : (mode === ThemeMode.DARK ? alpha(paletteColor.grey[900]!, 0.45) : paletteColor.grey[500]),
        disabled: mode === ThemeMode.CLASSIC ? '#666666' : (mode === ThemeMode.DARK ? alpha(paletteColor.grey[900]!, 0.1) : paletteColor.grey[400])
      },
      action: {
        disabled: paletteColor.grey[300]
      },
      divider: mode === ThemeMode.CLASSIC ? '#404040' : (mode === ThemeMode.DARK ? alpha(paletteColor.grey[900]!, 0.05) : paletteColor.grey[200]),
      background: {
        paper: mode === ThemeMode.CLASSIC ? '#1a1a1a' : (mode === ThemeMode.DARK ? paletteColor.grey[100] : paletteColor.grey[0]),
        default: mode === ThemeMode.CLASSIC ? '#000000' : paletteColor.grey.A50
      }
    }
  });
}
